
import { getActions } from '../sagas';

/**
 * Command `mapmultiscene.closeMultiScene`
 *
 */
function closeMultiScene(params, dispatch) {
    getActions(dispatch).setMmsPoint(null);
}

export default {
    name: 'mapmultiscene.closeMultiScene',
    execute: closeMultiScene
}
